import { API_URL } from "config";
import Http from "util/https";
import { ItemSelectParams, ItemSelectResponse } from "../types";

/**
 * ジョイフル用設定画面用・登録企業リスト検索API
 * @param params 商品リスト取得リクエストパラメータ
 * @returns total + managed_items[] レスポンスステータスコード
 */
export default async function productSelectApi(
  params: ItemSelectParams,
): Promise<ItemSelectResponse> {
  console.log('productSelectApi params:', params);
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/joyful/item/select`;
  const res = await http.post<ItemSelectResponse>(url, params);
  console.log(res);

  return res.data;
}
